(function () {
  'use strict';

  document.querySelectorAll('[data-auto-submit]').forEach(function (control) {
    control.addEventListener('change', function () {
      if (control.form) control.form.submit();
    });
  });

  var toggle = document.querySelector('[data-menu-toggle]');
  var navigation = document.querySelector('[data-main-nav]');
  if (toggle && navigation) {
    toggle.addEventListener('click', function () {
      var isOpen = navigation.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(isOpen));
      toggle.querySelector('span').textContent = isOpen ? '×' : '☰';
    });
  }

  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var select = form.querySelector('[data-variant-select]');
    var price = form.closest('.product-information') && form.closest('.product-information').querySelector('[data-product-price]');
    var message = form.querySelector('[data-form-message]');
    if (select && price) {
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      var parseCourseDate = function (text) {
        var normalized = String(text || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
        var numeric = normalized.match(/(?:^|\s)(\d{1,2})\.(\d{1,2})\.(\d{4})(?:\s|$)/);
        if (numeric) return new Date(Number(numeric[3]), Number(numeric[2]) - 1, Number(numeric[1]));
        var iso = normalized.match(/(?:^|\s)(\d{4})-(\d{1,2})-(\d{1,2})(?:\s|$)/);
        if (iso) return new Date(Number(iso[1]), Number(iso[2]) - 1, Number(iso[3]));
        var months = { januar:0, january:0, janvier:0, febbraio:1, februar:1, february:1, fevrier:1, marz:2, march:2, mars:2, marzo:2, april:3, avril:3, aprile:3, mai:4, may:4, maggio:4, june:5, juni:5, juin:5, giugno:5, july:6, juli:6, juillet:6, luglio:6, august:7, aout:7, agosto:7, september:8, septembre:8, settembre:8, october:9, oktober:9, octobre:9, ottobre:9, november:10, novembre:10, december:11, dezember:11, decembre:11, dicembre:11 };
        var words = normalized.match(/(?:^|\s)(\d{1,2})\.?\s+([a-z]+)\s+(\d{4})(?:\s|$)/);
        if (words && Object.prototype.hasOwnProperty.call(months, words[2])) return new Date(Number(words[3]), months[words[2]], Number(words[1]));
        var english = normalized.match(/(?:^|\s)([a-z]+)\s+(\d{1,2}),?\s+(\d{4})(?:\s|$)/);
        if (english && Object.prototype.hasOwnProperty.call(months, english[1])) return new Date(Number(english[3]), months[english[1]], Number(english[2]));
        return null;
      };
      Array.prototype.forEach.call(select.options, function (option) {
        var courseDate = parseCourseDate(option.textContent);
        if (!courseDate) return;
        if (courseDate < today) {
          option.disabled = true;
          option.dataset.pastDate = 'true';
          if (option.textContent.indexOf('Termin vorbei') === -1) option.textContent += ' – Termin vorbei';
        }
      });
      var preferredRegion = new URLSearchParams(window.location.search).get('praeferenz_ort');
      var normalizeSearch = function (value) { return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase(); };
      var preferredOption = preferredRegion && Array.prototype.find.call(select.options, function (option) {
        return !option.disabled && normalizeSearch(option.textContent).indexOf(normalizeSearch(preferredRegion)) !== -1;
      });
      if (preferredOption) select.value = preferredOption.value;
      if (preferredOption || (select.selectedOptions[0] && select.selectedOptions[0].disabled)) {
        var firstBookable = preferredOption || Array.prototype.find.call(select.options, function (option) { return !option.disabled; });
        if (firstBookable) {
          select.value = firstBookable.value;
          price.textContent = firstBookable.getAttribute('data-price') || price.textContent;
          var nextCourseDate = document.querySelector('[data-next-course-date]');
          if (nextCourseDate) nextCourseDate.textContent = firstBookable.textContent.replace(/\s+–\s+Termin vorbei$/, '').trim();
        } else {
          form.querySelector('button[type="submit"]').disabled = true;
          if (message) message.textContent = 'Für dieses Angebot ist aktuell kein buchbarer Termin freigegeben.';
        }
      }
      select.addEventListener('change', function () {
        var option = select.options[select.selectedIndex];
        price.textContent = option.getAttribute('data-price') || price.textContent;
        var nextCourseDate = document.querySelector('[data-next-course-date]');
        if (nextCourseDate) nextCourseDate.textContent = option.textContent.trim();
      });
    }
    form.addEventListener('submit', function () {
      if (message) message.textContent = 'Der Artikel wird in den Warenkorb gelegt …';
    });
  });

  document.querySelectorAll('.product-thumbnails img').forEach(function (thumbnail) {
    thumbnail.addEventListener('click', function () {
      var gallery = thumbnail.closest('.product-gallery');
      var main = gallery && gallery.querySelector(':scope > img');
      if (main) {
        main.src = thumbnail.src.replace(/width=\d+/, 'width=1200');
        main.alt = thumbnail.alt;
      }
    });
  });

  var printProductButton = document.querySelector('[data-print-product]');
  if (printProductButton) {
    printProductButton.addEventListener('click', function () { window.print(); });
  }

  var companyOrderLink = document.querySelector('[data-company-order-link]');
  var productQuantity = document.querySelector('[data-product-quantity]');
  if (companyOrderLink && productQuantity) {
    var syncCompanyQuantity = function () {
      var url = new URL(companyOrderLink.href, window.location.origin);
      url.searchParams.set('menge', String(Math.max(1, Number(productQuantity.value) || 1)));
      companyOrderLink.href = url.toString();
    };
    productQuantity.addEventListener('input', syncCompanyQuantity);
    syncCompanyQuantity();
  }

  var companyRequestForm = document.querySelector('[data-company-request-form]');
  if (companyRequestForm) {
    var companyParams = new URLSearchParams(window.location.search);
    var offerField = companyRequestForm.querySelector('[data-company-offer]');
    var participantsField = companyRequestForm.querySelector('[data-company-participants]');
    if (offerField && companyParams.get('angebot')) offerField.value = companyParams.get('angebot');
    if (participantsField && companyParams.get('menge')) participantsField.value = Math.max(1, Number(companyParams.get('menge')) || 1);
    companyRequestForm.querySelectorAll('[data-company-prefill]').forEach(function (field) {
      var value = companyParams.get(field.dataset.companyPrefill);
      if (value) field.value = value;
    });
  }

  var contactForm = document.querySelector('.contact-form');
  if (contactForm) {
    var contactParams = new URLSearchParams(window.location.search);
    var contactTopic = contactForm.querySelector('#ContactTopic');
    var requestedTopic = contactParams.get('thema');
    if (contactTopic && requestedTopic) {
      var topicMatch = Array.prototype.find.call(contactTopic.options, function (option) { return option.value === requestedTopic; });
      if (topicMatch) contactTopic.value = requestedTopic;
    }
    var requestedProduct = contactParams.get('product');
    var productWrap = contactForm.querySelector('[data-contact-product-wrap]');
    var productField = contactForm.querySelector('[data-contact-product]');
    if (requestedProduct && productWrap && productField) {
      productField.value = requestedProduct;
      productWrap.hidden = false;
    }
  }

  var fundingNavigator = document.querySelector('[data-funding-navigator]');
  if (fundingNavigator) {
    var fundingShow = fundingNavigator.querySelector('[data-funding-show]');
    var fundingResults = fundingNavigator.querySelector('[data-funding-results]');
    var fundingStatus = fundingNavigator.querySelector('[data-funding-status]');
    var fundingCards = Array.prototype.slice.call(fundingNavigator.querySelectorAll('[data-funding-result]'));
    var showFundingResult = function () {
      var selected = fundingNavigator.querySelector('input[name="funding_route"]:checked');
      if (!selected) {
        if (fundingStatus) fundingStatus.textContent = fundingNavigator.dataset.fundingChoose || '';
        return;
      }
      var activeCard = null;
      fundingCards.forEach(function (card) {
        var active = card.dataset.fundingResult === selected.value;
        card.hidden = !active;
        if (active) activeCard = card;
      });
      if (fundingResults) fundingResults.hidden = false;
      if (fundingStatus) fundingStatus.textContent = '';
      if (activeCard) activeCard.focus();
    };
    if (fundingShow) fundingShow.addEventListener('click', showFundingResult);

    var sbfiCalculator = fundingNavigator.querySelector('[data-sbfi-calculator]');
    if (sbfiCalculator) {
      var sbfiExam = sbfiCalculator.querySelector('[data-sbfi-exam]');
      var sbfiFee = sbfiCalculator.querySelector('[data-sbfi-fee]');
      var sbfiButton = sbfiCalculator.querySelector('[data-sbfi-calculate]');
      var sbfiOutput = sbfiCalculator.querySelector('[data-sbfi-output]');
      var calcTranslations = {
        de: { prefix: 'Unverbindliche Orientierung: ', low: 'Anrechenbare Kursgebühren unter CHF 1’000 erreichen die Mindestgrenze pro Gesuch nicht.', suffix: ' Kein Beitragsentscheid.' },
        fr: { prefix: 'Orientation sans engagement : ', low: 'Des frais pris en compte inférieurs à CHF 1’000 n’atteignent pas le minimum par demande.', suffix: ' Ceci ne constitue pas une décision.' },
        it: { prefix: 'Orientamento non vincolante: ', low: 'Tasse computabili inferiori a CHF 1’000 non raggiungono il minimo per domanda.', suffix: ' Non è una decisione.' },
        en: { prefix: 'Non-binding orientation: ', low: 'Eligible fees below CHF 1,000 do not meet the minimum per application.', suffix: ' This is not a funding decision.' }
      };
      var calculateSbfi = function () {
        var fee = Math.max(0, Number(sbfiFee && sbfiFee.value) || 0);
        var language = (document.documentElement.lang || 'de').slice(0, 2);
        var copy = calcTranslations[language] || calcTranslations.de;
        if (!sbfiOutput || !fee) return;
        if (fee < 1000) {
          sbfiOutput.textContent = copy.low;
          return;
        }
        var cap = sbfiExam && sbfiExam.value === 'hfp' ? 10500 : 9500;
        var contribution = Math.min(fee * 0.5, cap);
        var formatted = new Intl.NumberFormat(language + '-CH', { style: 'currency', currency: 'CHF', maximumFractionDigits: 0 }).format(contribution);
        sbfiOutput.textContent = copy.prefix + formatted + copy.suffix;
      };
      if (sbfiButton) sbfiButton.addEventListener('click', calculateSbfi);
    }
  }

  var printFundingButton = document.querySelector('[data-print-funding]');
  if (printFundingButton) printFundingButton.addEventListener('click', function () { window.print(); });

  var accessibilityRoot = document.querySelector('[data-accessibility-tools]');
  if (accessibilityRoot) {
    var html = document.documentElement;
    var panel = accessibilityRoot.querySelector('#AccessibilityPanel');
    var trigger = accessibilityRoot.querySelector('[data-accessibility-open]');
    var backdrop = accessibilityRoot.querySelector('.accessibility-backdrop');
    var classes = { text: 'a11y-text', contrast: 'a11y-contrast', spacing: 'a11y-spacing', motion: 'a11y-motion', links: 'a11y-links' };
    var load = function () { try { return JSON.parse(localStorage.getItem('bd_accessibility') || '{}'); } catch (_) { return {}; } };
    var prefs = load();
    Object.keys(classes).forEach(function (key) { html.classList.toggle(classes[key], !!prefs[key]); });
    var syncButtons = function () {
      accessibilityRoot.querySelectorAll('[data-accessibility-action]').forEach(function (button) { button.setAttribute('aria-pressed', String(!!prefs[button.dataset.accessibilityAction])); });
      var selectedVersion = prefs.textVersion || 'standard';
      accessibilityRoot.querySelectorAll('[data-text-version]').forEach(function (button) { button.setAttribute('aria-pressed', String(button.dataset.textVersion === selectedVersion)); });
      var versionPanel = accessibilityRoot.querySelector('[data-text-version-panel]');
      if (versionPanel) versionPanel.hidden = selectedVersion === 'standard';
      accessibilityRoot.querySelectorAll('[data-text-version-copy]').forEach(function (copy) { copy.hidden = copy.dataset.textVersionCopy !== selectedVersion; });
    };
    var setPanel = function (open) {
      if (!panel || !backdrop || !trigger) return;
      panel.hidden = !open;
      backdrop.hidden = !open;
      panel.setAttribute('aria-hidden', String(!open));
      trigger.setAttribute('aria-expanded', String(open));
      if (open) {
        var closeButton = panel.querySelector('.accessibility-close');
        if (closeButton) closeButton.focus();
      } else {
        trigger.focus();
      }
    };
    trigger.addEventListener('click', function () { setPanel(true); });
    accessibilityRoot.querySelectorAll('[data-accessibility-close]').forEach(function (button) { button.addEventListener('click', function () { setPanel(false); }); });
    accessibilityRoot.querySelectorAll('[data-accessibility-action]').forEach(function (button) { button.addEventListener('click', function () { var key = button.dataset.accessibilityAction; prefs[key] = !prefs[key]; html.classList.toggle(classes[key], prefs[key]); localStorage.setItem('bd_accessibility', JSON.stringify(prefs)); syncButtons(); }); });
    var accessibilityStatus = accessibilityRoot.querySelector('[data-accessibility-status]');
    var setAccessibilityStatus = function (message) { if (accessibilityStatus) accessibilityStatus.textContent = message; };
    accessibilityRoot.querySelector('[data-accessibility-reset]').addEventListener('click', function () { prefs = {}; Object.values(classes).forEach(function (name) { html.classList.remove(name); }); localStorage.removeItem('bd_accessibility'); if ('speechSynthesis' in window) window.speechSynthesis.cancel(); setAccessibilityStatus('Alle persönlichen Anzeigeeinstellungen wurden zurückgesetzt.'); syncButtons(); });
    accessibilityRoot.querySelector('[data-accessibility-read]').addEventListener('click', function () { if (!('speechSynthesis' in window)) { setAccessibilityStatus('Die Vorlesefunktion wird von diesem Browser nicht unterstützt. Bitte verwenden Sie den integrierten Screenreader Ihres Geräts.'); return; } window.speechSynthesis.cancel(); var mainContent = document.querySelector('#MainContent'); var text = mainContent ? mainContent.innerText : ''; if (!text.trim()) { setAccessibilityStatus('Auf dieser Seite wurde kein lesbarer Hauptinhalt gefunden.'); return; } var utterance = new SpeechSynthesisUtterance(text); utterance.lang = document.documentElement.lang || 'de-CH'; utterance.onstart = function () { setAccessibilityStatus('Vorlesen gestartet.'); }; utterance.onend = function () { setAccessibilityStatus('Vorlesen beendet.'); }; utterance.onerror = function () { setAccessibilityStatus('Vorlesen konnte in diesem Browser nicht gestartet werden.'); }; window.speechSynthesis.speak(utterance); });
    accessibilityRoot.querySelector('[data-accessibility-stop]').addEventListener('click', function () { if ('speechSynthesis' in window) window.speechSynthesis.cancel(); setAccessibilityStatus('Vorlesen gestoppt.'); });
    accessibilityRoot.querySelectorAll('[data-text-version]').forEach(function (button) {
      button.addEventListener('click', function () {
        prefs.textVersion = button.dataset.textVersion || 'standard';
        localStorage.setItem('bd_accessibility', JSON.stringify(prefs));
        syncButtons();
        if (prefs.textVersion === 'standard') setAccessibilityStatus('Die normale Textversion ist aktiv.');
        if (prefs.textVersion === 'simple') setAccessibilityStatus('Die Kurzfassung in einfacher Sprache ist geöffnet.');
        if (prefs.textVersion === 'easy') setAccessibilityStatus('Die Orientierung in Leichter Sprache ist geöffnet.');
      });
    });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && !panel.hidden) setPanel(false); });
    syncButtons();
  }

  var companyFit = document.querySelector('[data-company-fit]');
  if (companyFit) {
    var companyFitButton = companyFit.querySelector('[data-company-fit-submit]');
    var companyFitValidation = companyFit.querySelector('[data-company-fit-validation]');
    var companyFitResult = companyFit.querySelector('[data-company-fit-result]');
    var companyFitSelection = companyFit.querySelector('[data-company-fit-selection]');
    var companyFitLink = companyFit.querySelector('[data-company-fit-link]');
    var selectedCompanyLabel = function (name) {
      var input = companyFit.querySelector('input[name="' + name + '"]:checked');
      return input ? (input.closest('label').innerText || input.value).trim() : '';
    };
    if (companyFitButton) companyFitButton.addEventListener('click', function () {
      var goal = companyFit.querySelector('input[name="company_goal"]:checked');
      var format = companyFit.querySelector('input[name="company_format"]:checked');
      var timing = companyFit.querySelector('input[name="company_timing"]:checked');
      if (!goal || !format || !timing) {
        if (companyFitValidation) companyFitValidation.hidden = false;
        return;
      }
      if (companyFitValidation) companyFitValidation.hidden = true;
      var selection = [selectedCompanyLabel('company_goal'), selectedCompanyLabel('company_format'), selectedCompanyLabel('company_timing')].join(' · ');
      if (companyFitSelection) companyFitSelection.textContent = selection;
      if (companyFitLink) {
        try {
          var requestUrl = new URL(companyFit.dataset.requestBase || '/pages/firmenbestellung', window.location.origin);
          requestUrl.searchParams.set('bedarf', goal.value);
          requestUrl.searchParams.set('format', format.value);
          requestUrl.searchParams.set('planung', timing.value);
          companyFitLink.href = requestUrl.pathname + requestUrl.search;
        } catch (_) {}
      }
      if (companyFitResult) {
        companyFitResult.hidden = false;
        companyFitResult.focus();
      }
    });
  }

  /*
   * Delegated safety net: Shopify can re-render theme sections in the editor
   * and after locale changes. In that case the direct listener above points to
   * the replaced button. Delegation keeps the accessibility dialog usable on
   * every page and in every newly rendered section.
   */
  document.addEventListener('click', function (event) {
    var openButton = event.target.closest && event.target.closest('[data-accessibility-open]');
    if (!openButton) return;
    var root = openButton.closest('[data-accessibility-tools]');
    if (!root) return;
    var currentPanel = root.querySelector('#AccessibilityPanel');
    var currentBackdrop = root.querySelector('.accessibility-backdrop');
    if (!currentPanel || !currentBackdrop) return;
    currentPanel.hidden = false;
    currentBackdrop.hidden = false;
    currentPanel.setAttribute('aria-hidden', 'false');
    openButton.setAttribute('aria-expanded', 'true');
    var currentClose = currentPanel.querySelector('.accessibility-close');
    if (currentClose) currentClose.focus();
  });

  var collectionSearch = document.querySelector('[data-collection-search]');
  if (collectionSearch) {
    var collectionCards = Array.prototype.slice.call(document.querySelectorAll('[data-product-card]'));
    var collectionResult = document.querySelector('[data-collection-result]');
    var quickFilterRoot = document.querySelector('[data-catalog-quick-filters]');
    var quickFilterButtons = quickFilterRoot ? Array.prototype.slice.call(quickFilterRoot.querySelectorAll('[data-catalog-quick-filter]')) : [];
    var quickFilterState = { topic: 'all', form: 'all', purchase: 'all' };
    var includesAny = function (value, terms) {
      return terms.some(function (term) { return value.indexOf(term) !== -1; });
    };
    var matchesQuickFilter = function (card, group, value) {
      if (value === 'all') return true;
      var tags = (card.dataset.productTags || '').toLocaleLowerCase('de-CH');
      var searchable = (card.dataset.productSearch || card.textContent).toLocaleLowerCase('de-CH');
      if (group === 'topic') {
        if (value === 'pflege') return includesAny(tags, ['pflege', 'angehörigenpflege', 'praxistransfer']);
        if (value === 'neuro') return includesAny(tags + ' ' + searchable, ['demenz', 'autismus', 'neurodiversität']);
        if (value === 'schutz') return includesAny(tags + ' ' + searchable, ['schutz', 'deeskalation', 'sicherheit']);
        if (value === 'betrieb') return includesAny(tags + ' ' + searchable, ['bildungsbetrieb', 'qualität', 'vertrieb', 'curriculum']);
        if (value === 'organisation') return includesAny(tags + ' ' + searchable, ['führung', 'personalpraxis', 'organisation']);
      }
      if (group === 'form') {
        if (value === 'concept') return includesAny(searchable, ['konzept', 'qms', 'curriculum', 'betriebssystem']);
        if (value === 'template') return includesAny(searchable, ['vorlage', 'matrix', 'dokumentation']);
        if (value === 'toolkit') return includesAny(searchable, ['toolkit', 'starterkit', 'paket', 'kartenset']);
        if (value === 'portfolio') return includesAny(searchable, ['mappe', 'portfolio']);
        if (value === 'evaluation') return includesAny(searchable, ['evaluation', 'werkzeug', 'audit']);
      }
      if (group === 'purchase') {
        if (value === 'request') return tags.indexOf('auf anfrage') !== -1;
        if (value === 'order') return tags.indexOf('auftragsprodukt') !== -1;
        if (value === 'preparing') return tags.indexOf('in fachlicher vorbereitung') !== -1;
        if (value === 'available') return card.dataset.productAvailable === 'true' && !includesAny(tags, ['auf anfrage', 'auftragsprodukt', 'in fachlicher vorbereitung']);
      }
      return true;
    };
    var filterCollectionCards = function () {
      var term = collectionSearch.value.trim().toLocaleLowerCase('de-CH');
      var visible = 0;
      collectionCards.forEach(function (card) {
        var searchable = (card.dataset.productSearch || card.textContent).toLocaleLowerCase('de-CH');
        var matchesSearch = !term || searchable.indexOf(term) !== -1;
        var matchesFilters = Object.keys(quickFilterState).every(function (group) {
          return matchesQuickFilter(card, group, quickFilterState[group]);
        });
        var matches = matchesSearch && matchesFilters;
        card.hidden = !matches;
        if (matches) visible += 1;
      });
      if (collectionResult) collectionResult.textContent = visible + ' von ' + collectionCards.length + ' sichtbar';
    };
    collectionSearch.addEventListener('input', filterCollectionCards);
    quickFilterButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var groupRoot = button.closest('[data-filter-group]');
        var group = groupRoot ? groupRoot.dataset.filterGroup : '';
        if (!group) return;
        quickFilterState[group] = button.dataset.filterValue || 'all';
        Array.prototype.forEach.call(groupRoot.querySelectorAll('[data-catalog-quick-filter]'), function (candidate) {
          var selected = candidate === button;
          candidate.classList.toggle('is-active', selected);
          candidate.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        filterCollectionCards();
      });
    });
    var quickFilterReset = quickFilterRoot ? quickFilterRoot.querySelector('[data-catalog-filter-reset]') : null;
    if (quickFilterReset) {
      quickFilterReset.addEventListener('click', function () {
        quickFilterState = { topic: 'all', form: 'all', purchase: 'all' };
        quickFilterButtons.forEach(function (button) {
          var selected = button.dataset.filterValue === 'all';
          button.classList.toggle('is-active', selected);
          button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        collectionSearch.value = '';
        filterCollectionCards();
        collectionSearch.focus();
      });
    }
    filterCollectionCards();
  }


  var cookieRoot = document.querySelector('[data-cookie-consent]');
  var cookieSettings = document.querySelector('[data-cookie-settings]');
  if (cookieRoot && cookieSettings) {
    var consentKey = 'bd_cookie_consent_v1';
    var readConsent = function () { try { return localStorage.getItem(consentKey); } catch (_) { return null; } };
    var applyConsent = function (approved) {
      try { localStorage.setItem(consentKey, approved ? 'all' : 'essential'); } catch (_) {}
      if (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.setTrackingConsent) {
        Shopify.customerPrivacy.setTrackingConsent(approved, function () {});
      }
      cookieRoot.hidden = true;
      cookieSettings.hidden = false;
    };
    var openConsent = function () {
      cookieRoot.hidden = false;
      cookieSettings.hidden = true;
      var firstButton = cookieRoot.querySelector('button');
      if (firstButton) firstButton.focus();
    };
    var acceptButton = cookieRoot.querySelector('[data-cookie-accept]');
    var essentialButton = cookieRoot.querySelector('[data-cookie-essential]');
    if (acceptButton) acceptButton.addEventListener('click', function () { applyConsent(true); });
    if (essentialButton) essentialButton.addEventListener('click', function () { applyConsent(false); });
    cookieSettings.addEventListener('click', openConsent);
    if (readConsent()) cookieSettings.hidden = false; else openConsent();
  }
})();
